import VideoJS from 'video.js';

import * as Controls from '../../ui/UIControlsNames';
import mutedSVG from '../../ui/icons/muted.svg';
import volumeSVG from '../../ui/icons/volume.svg';

const MuteToggle = VideoJS.getComponent('MuteToggle');

class ASMuteToggle extends MuteToggle {
    createEl() {
        const el =  super.createEl(...arguments);

        const volumeIcon = VideoJS.dom.createEl('span', {
            innerHTML: volumeSVG,
            className: 'vjs-icon vjs-icon--volume',
        }, {
            'aria-hidden': 'true'
        });

        const mutedIcon = VideoJS.dom.createEl('span', {
            innerHTML: mutedSVG,
            className: 'vjs-icon vjs-icon--muted',
        }, {
            'aria-hidden': 'true'
        });

        el.appendChild(volumeIcon);
        el.appendChild(mutedIcon);

        return el;
    }

    buildCSSClass() {
        return `as-mute-control ${super.buildCSSClass()}`;
    }
}

VideoJS.registerComponent(Controls.MUTE_TOGGLE, ASMuteToggle);

export default ASMuteToggle;



// WEBPACK FOOTER //
// ./src/player/components/ASMuteToggle.js